module.exports = __webpack_public_path__ + "static/media/cs3216-logo-white.abd35fa5.png";